const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  hasLoad: state => state.permission.hasLoad,
  routers: state => state.permission.routers,
  addRouters: state => state.permission.addRouters
}
export default getters
